import { disableFragmentWarnings } from '@apollo/client';

/**
 * Shared fragment constants (e.g. PAID_SERVICE_FIELDS, RESUME_CARD_FIELDS) are
 * interpolated into many sibling documents. graphql-tag deduplicates them and
 * logs a "fragment with name X already exists" warning for every repeat. The
 * dedup is harmless — Apollo keeps the first definition — but the warnings
 * flooded the console and were captured as Bugsnag breadcrumbs.
 *
 * This must run before the first `gql` template that embeds a shared fragment
 * is parsed, so it is imported for its side effect at the top of `fields.ts`
 * (the earliest common dependency of every document that reuses a fragment).
 */
disableFragmentWarnings();
